// extracted by mini-css-extract-plugin
module.exports = {"App":"Laws__App__2vJZQ","Center":"Laws__Center__1aAlL","Row":"Laws__Row__35ct2","RowH":"Laws__RowH__2J_Dl","Text":"Laws__Text__3Fu9u","Width":"Laws__Width__3R9TW"};